import { useAppSelector } from 'modules/common/hooks/redux';
import {
  isProjectStatusInReTake,
  isProjectStatusProoferPending,
  isProjectStatusProofingInProgress,
  isWebSiteUpToDateSelector,
} from 'redux/reducers/project/selectors';
import { useIsProoferRole } from 'modules/common/hooks/useIsProoferRole';
import { useIsScorerRole } from 'modules/common/hooks/useIsScorerRole';

export function useCanComment(): boolean {
  const inProoferPending = useAppSelector(isProjectStatusProoferPending);
  const inProofingInProgress = useAppSelector(isProjectStatusProofingInProgress);
  const inRetake = useAppSelector(isProjectStatusInReTake);
  const isWebSiteUptoDate = useAppSelector(isWebSiteUpToDateSelector);
  const isProofer = useIsProoferRole();
  const isScorer = useIsScorerRole();

  return !isScorer && (isProofer && ((inProofingInProgress || inRetake) && isWebSiteUptoDate));
}
